import { AccessCodes, IAccessCodes } from "./Sidemenus";
import {
  CandidateRequestType,
  EnquiryType,
  // RoleTypes,
} from "../Constant/Enums";
import { useSelector } from "react-redux";
import { userData } from "../Store/Slice/userSlice";
import { RoleTypes } from "../Generated/orval-apis/cit.schemas";
import { notification } from "antd";
import * as React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { LazyPage, LazyWrapper } from "../Utilities/LazyLoader";
import IDCardTemplate from "../Admin/Masters/Identity Cards Template/IDCardTemplate";
import QueryList from "../pages/LeaveRequests/QueryList";
const Fees = LazyPage(() => import("../pages/Fees/Fees"));
const StudentsList = LazyPage(() => import("../pages/Students/StudentsList"));
const Batch = LazyPage(() => import("../Admin/Masters/Batch/Batch"));
const Attendance = LazyPage(() => import("../Admin/Attendance/Attendance"));
const Holiday = LazyPage(() => import("../Admin/Masters/Holidays/Holiday"));
const Curriculum = LazyPage(
  () => import("../Admin/Masters/Curriculum/Curriculum")
);
const Stream = LazyPage(() => import("../Admin/Masters/Stream/Stream"));
const Class = LazyPage(() => import("../Admin/Masters/Class/Class"));
const PaymentMedium = LazyPage(
  () => import("../Admin/Masters/PaymentMethod/PaymentMedium")
);
const Credentials = LazyPage(
  () => import("../Admin/Masters/Credentials/Credentials")
);
const Document = LazyPage(() => import("../Admin/Masters/Document/Document"));
const Status = LazyPage(() => import("../Admin/Masters/Status/Status"));
const Medium = LazyPage(() => import("../Admin/Masters/Medium/Medium"));
const Setting = LazyPage(() => import("../pages/setting/Setting"));
const Course = LazyPage(() => import("../Admin/Masters/Course/Course"));
const Subjects = LazyPage(() => import("../Admin/Masters/Subjects/Subjects"));
const Semester = LazyPage(() => import("../Admin/Masters/Semester/Semester"));
const User = LazyPage(() => import("../pages/setting/User/User"));
const RoleList = LazyPage(() => import("../Admin/Masters/Role/RoleList"));
const FeesType = LazyPage(() => import("../Admin/Masters/FeesType/FeesType"));
const Counselor = LazyPage(
  () => import("../Admin/Masters/Counselor/Counselor")
);
const ProcessSteps = LazyPage(
  () => import("../Admin/Masters/ProcessSteps/ProcessSteps")
);
const EnquiryLead = LazyPage(() => import("../Enquiry/EnquiryLead"));
const ProcessStepSetting = LazyPage(
  () => import("../Admin/Masters/ProcessSteps/ProcessStepSetting")
);
const ActionConfiguration = LazyPage(
  () => import("../Admin/Masters/ProcessSteps/ActionConfiguration")
);
const Source = LazyPage(() => import("../Admin/Masters/Source/Source"));
const AssesmentCategoryList = LazyPage(
  () => import("../Admin/Masters/AssessmentCategory/AssessmentCategoryList")
);
const Reason = LazyPage(() => import("../Admin/Masters/Reason/Reason"));
const Platform = LazyPage(() => import("../Admin/Masters/Platform/Platform"));
const Reminder = LazyPage(() => import("../Admin/Masters/Reminder/Reminder"));
const Task = LazyPage(() => import("../Admin/Masters/Task/Task"));
const MailTemplates = LazyPage(
  () => import("../Admin/Masters/MailTemplates/MailTemplates")
);
const Session = LazyPage(() => import("../Admin/Masters/Session/Session"));
const ManageSchedule = LazyPage(() => import("../pages/LMS/ManageSchedule"));
const ClassandSubjects = LazyPage(() => import("../pages/LMS/Class&Subjects"));
const LessionPlanning = LazyPage(() => import("../pages/LMS/LessionPlanning"));
const Room = LazyPage(() => import("../Admin/Masters/RoomNo/Room"));
const DesignCourse = LazyPage(
  () => import("../component/DesignCourse/DesignCourse")
);
const Sections = LazyPage(() => import("../Admin/Masters/Sections/Sections"));
const Degree = LazyPage(
  () => import("../pages/GraduationAlumni/Degree/AddEditDegree")
);
const DisplayAssements = LazyPage(
  () =>
    import(
      "../pages/Assessments/Assessments&Grades/Assessments/DisplayAssements"
    )
);
const FacultyMapWithDept = LazyPage(
  () => import("../Admin/Masters/FacultyMapWithDept/FacultyMapWithDept")
);
const Ecard = LazyPage(() => import("../component/Ecards/Ecards"));
const SubjectAllocationList = LazyPage(
  () => import("../pages/LMS/SubjectAlllocation/SubjectAllocationList")
);
const SubjectTypes = LazyPage(
  () => import("../Admin/Masters/SubjectTypes/SubjectTypes")
);
const Dashboard = LazyPage(() => import("../pages/Dashboard/Dashboard"));
const Page404 = LazyPage(() => import("./Page404"));
const MandatoryDocumentType = LazyPage(
  () => import("../Admin/Masters/Document/MandatoryDocumentType")
);
const TATACallLogs = LazyPage(() => import("../pages/Calls/TATACallLogs"));
const RequestsTab = LazyPage(
  () => import("../pages/LeaveRequests/RequestsTab")
);
const PrivacyPolicy = LazyPage(
  () => import("../Admin/Masters/PrivacyPolicy/PrivacyPolicy")
);
const LeaveTypes = LazyPage(
  () => import("../Admin/Masters/LeaveTypes/LeaveTypes")
);
const BioMetricDeviceList = LazyPage(
  () => import("../pages/setting/Attendance/BioMetricDeviceList")
);
const BioMetricDeviceEmployeeList = LazyPage(
  () => import("../pages/setting/Attendance/BioMetricDeviceEmployeeList")
);
const NoticeList = LazyPage(() => import("../Admin/Masters/Notice/NoticeList"));
const AppVersionsList = LazyPage(
  () => import("../component/AppVersion/AppVersionsList")
);
const GradeBook = LazyPage(
  () => import("../pages/Assessments/Grade Book/GradeBook")
);
const AddAllSubjectMarks = LazyPage(
  () => import("../pages/Assessments/Grade Book/MarksEntry/AddAllSubjectMarks")
);
const AddSingleSubjectMarks = LazyPage(
  () =>
    import("../pages/Assessments/Grade Book/MarksEntry/AddSingleSubjectMarks")
);
const SingleStudentResult = LazyPage(
  () => import("../pages/Assessments/Grade Book/SingleStudentResult")
);
const FacultyType = LazyPage(
  () => import("../Admin/Masters/FacultyType/FacultyType")
);
const ShiftList = LazyPage(() => import("../Admin/Masters/Shift/ShiftList"));
const NewStudentForm = LazyPage(() => import("../Enquiry/NewStudentForm"));
const Reports = LazyPage(() => import("../pages/Reports/Reports"));
const DatewiseAttReport = LazyPage(
  () => import("../pages/Reports/DatewiseAttReport")
);
const WorkingHoursReport = LazyPage(
  () => import("../pages/Reports/WorkingHoursReports")
);
const FeesStructure = LazyPage(
  () => import("../Admin/Masters/Fees Master/FeesStructure")
);
const AddEnquiry = LazyPage(() => import("../Enquiry/AddEnquiry"));
const PaymentOrders = LazyPage(() => import("../pages/Fees/PaymentOrders"));
const ExamsList = LazyPage(
  () => import("../pages/Assessments/Questions Section/ExamsList")
);
const Gender = LazyPage(() => import("../Admin/Masters/Gender/Gender"));
const ExamInstructions = LazyPage(
  () => import("../component/Student/ExamInstructions")
);
const StudentExamList = LazyPage(
  () => import("../component/Student/StudentExamList")
);
const StudentExam = LazyPage(() => import("../component/Student/StudentExam"));
const CheckExamList = LazyPage(
  () => import("../pages/Assessments/Grade Book/checkExamList")
);
const ExamStudentsAnswerSheetList = LazyPage(
  () => import("../pages/Assessments/Grade Book/ExamStudentsAnswerSheetList")
);
const ExamIndividualStudentAnswerSheet = LazyPage(
  () =>
    import("../pages/Assessments/Grade Book/ExamIndividualStudentAnswerSheet")
);
const EnquiryDashboard = LazyPage(
  () => import("../pages/Dashboard/EnquiryDashboard")
);
const AdmissionEnquiry = LazyPage(() => import("../Enquiry/AdmissionEnquiry"));
const EmployeeReferralList = LazyPage(
  () => import("../Admin/Masters/EmployeeReferral/EmployeeReferralList")
);
const StudentResultList = LazyPage(
  () => import("../component/Student/Results/StudentResultList")
);
const ExamTemplatesList = LazyPage(
  () => import("../Admin/Masters/ExamInstructionsTemplates/ExamTemplatesList")
);
const CounsellorTataReport = LazyPage(
  () => import("../pages/Reports/CounsellorTataReport")
);
const CounsellorLeadManagementReport = LazyPage(
  () => import("../pages/Reports/CounsellorLeadManagementReport")
);
const CompanyList = LazyPage(() => import("../Admin/SuperAdmin/CompanyList"));

const Enable2FA=LazyPage(()=>import("./Login/Enable2FA"));
// import Fees from "../pages/Fees/Fees";
// import StudentsList from "../pages/Students/StudentsList";
// import Batch from "../Admin/Masters/Batch/Batch";
// import Attendance from "../Admin/Attendance/Attendance";
// import Holiday from "../Admin/Masters/Holidays/Holiday";
// import Curriculum from "../Admin/Masters/Curriculum/Curriculum";
// import Stream from "../Admin/Masters/Stream/Stream";
// import Class from "../Admin/Masters/Class/Class";
// import PaymentMedium from "../Admin/Masters/PaymentMethod/PaymentMedium";
// import Credentials from "../Admin/Masters/Credentials/Credentials";
// import Document from "../Admin/Masters/Document/Document";
// import Status from "../Admin/Masters/Status/Status";
// import Medium from "../Admin/Masters/Medium/Medium";
// import Setting from "../pages/setting/Setting";
// import Course from "../Admin/Masters/Course/Course";
// import Subjects from "../Admin/Masters/Subjects/Subjects";
// import Semester from "../Admin/Masters/Semester/Semester";
// import User from "../pages/setting/User/User";
// import RoleList from "../Admin/Masters/Role/RoleList";
// import FeesType from "../Admin/Masters/FeesType/FeesType";
// import Counselor from "../Admin/Masters/Counselor/Counselor";
// import ProcessSteps from "../Admin/Masters/ProcessSteps/ProcessSteps";
// import EnquiryLead from "../Enquiry/EnquiryLead";
// import ProcessStepSetting from "../Admin/Masters/ProcessSteps/ProcessStepSetting";
// import ActionConfiguration from "../Admin/Masters/ProcessSteps/ActionConfiguration";
// import Admission_Enquiry from "../Enquiry/Admission_Enquiry";
// import Source from "../Admin/Masters/Source/Source";
// import Reason from "../Admin/Masters/Reason/Reason";
// import Platform from "../Admin/Masters/Platform/Platform";
// import Reminder from "../Admin/Masters/Reminder/Reminder";
// import Task from "../Admin/Masters/Task/Task";
// import MailTemplates from "../Admin/Masters/MailTemplates/MailTemplates";
// import Session from "../Admin/Masters/Session/Session";
// import ManageSchedule from "../pages/LMS/ManageSchedule";
// import ClassandSubjects from "../pages/LMS/Class&Subjects";
// import LessionPlanning from "../pages/LMS/LessionPlanning";
// import Room from "../Admin/Masters/RoomNo/Room";
// import DesignCourse from "../component/DesignCourse/DesignCourse";
// import Sections from "../Admin/Masters/Sections/Sections";
// import Degree from "../pages/GraduationAlumni/Degree/AddEditDegree";
// import Assessments_Grades from "../pages/Assessments/Assessments&Grades/Assessments_Grades";
// import FacultyMapWithDept from "../Admin/Masters/FacultyMapWithDept/FacultyMapWithDept";
// import Ecard from "../component/Ecards/Ecards";
// import SubjectAllocationList from "../pages/LMS/SubjectAlllocation/SubjectAllocationList";
// import SubjectTypes from "../Admin/Masters/SubjectTypes/SubjectTypes";
// import Dashboard from "../pages/Dashboard/Dashboard";
// import Page404 from "./Page404";
// import MandatoryDocumentType from "../Admin/Masters/Document/MandatoryDocumentType";
// import TATACallLogs from "../pages/Calls/TATACallLogs";
// import RequestsTab from "../pages/LeaveRequests/RequestsTab";
// import PrivacyPolicy from "../Admin/Masters/PrivacyPolicy/PrivacyPolicy";
// import LeaveTypes from "../Admin/Masters/LeaveTypes/LeaveTypes";
// import BioMetricDeviceList from "../pages/setting/Attendance/BioMetricDeviceList";
// import BioMetricDeviceEmployeeList from "../pages/setting/Attendance/BioMetricDeviceEmployeeList";
// import NoticeList from "../Admin/Masters/Notice/NoticeList";
// import AppVersionsList from "../component/AppVersion/AppVersionsList";
// import GradeBook from "../pages/Assessments/Grade Book/GradeBook";
// import AddAllSubjectMarks from "../pages/Assessments/Grade Book/MarksEntry/AddAllSubjectMarks";
// import AddSingleSubjectMarks from "../pages/Assessments/Grade Book/MarksEntry/AddSingleSubjectMarks";
// import SingleStudentResult from "../pages/Assessments/Grade Book/SingleStudentResult";
// import FacultyType from "../Admin/Masters/FacultyType/FacultyType";
// import ShiftList from "../Admin/Masters/Shift/ShiftList";
// import NewStudentForm from "../Enquiry/NewStudentForm";
// import Reports from "../pages/Reports/Reports";
// import DatewiseAttReport from "../pages/Reports/DatewiseAttReport";
// import WorkingHoursReport from "../pages/Reports/WorkingHoursReports";
// import FeesStructure from "../Admin/Masters/Fees Master/FeesStructure";
// import AddEnquiry from "../Enquiry/AddEnquiry";
// import PaymentOrders from "../pages/Fees/PaymentOrders";
// import QuestionSection from "../pages/Assessments/Questions Section/QuestionSection";
// import ExamsList from "../pages/Assessments/Questions Section/ExamsList";
// import Gender from "../Admin/Masters/Gender/Gender";
// import ExamInstructions from "../component/Student/ExamInstructions";
// import StudentExamList from "../component/Student/StudentExamList";
// import StudentExam from "../component/Student/StudentExam";
// import CheckExamList from "../pages/Assessments/Grade Book/checkExamList";
// import ExamStudentsAnswerSheetList from "../pages/Assessments/Grade Book/ExamStudentsAnswerSheetList";
// import ExamIndividualStudentAnswerSheet from "../pages/Assessments/Grade Book/ExamIndividualStudentAnswerSheet";
// import EnquiryDashboard from "../pages/Dashboard/EnquiryDashboard";
// import AdmissionEnquiry from "../Enquiry/AdmissionEnquiry";
// import EmployeeReferralList from "../Admin/Masters/EmployeeReferral/EmployeeReferralList";
// import StudentResultList from "../component/Student/Results/StudentResultList";
// import ExamTemplatesList from "../Admin/Masters/ExamInstructionsTemplates/ExamTemplatesList";
// import CounsellorTataReport from "../pages/Reports/CounsellorTataReport";
// import CounsellorLeadManagementReport from "../pages/Reports/CounsellorLeadManagementReport";

export const adminContext = React.createContext<any>(null);

const PageRoute: React.FC = () => {
  type NotificationType = "success" | "info" | "warning" | "error";
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (
    type: NotificationType,
    message: string | undefined
  ) => {
    api[type]({
      message: "",
      description: message,
      duration: 3,
      style: {
        width: 400,
        top: 18,
        borderRadius: 0,
        padding: "20px 12px",
      },
    });
  };
  // let rights: IAccessCodes =
  //  JSON.parse(
  //   localStorage.getItem("tp-user") + ""
  // )?.rights;

  let rights: IAccessCodes | undefined | null = useSelector(userData)?.rights;

  const userRoleType = useSelector(userData)?.roleType;

  return (
    <adminContext.Provider value={{ openNotification }}>
      {userRoleType !== RoleTypes.Student &&
        userRoleType !== RoleTypes.SuperAdmin && (
          <LazyWrapper>
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" />} />
              <Route path="/enable-2fa" element={<Enable2FA/>}/>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/add-enquiry" element={<AddEnquiry />} />
              {rights?.enquiries === AccessCodes.enquiries ? (
                // <Route path="/enquiry" element={<EnquiryFormStudents />} />
                <>
                  <Route path="/enquiry/*">
                    <Route index element={<AdmissionEnquiry />} />
                    <Route path=":id" element={<EnquiryLead />} />
                    {/* <Route path="addEditEnquiry" element={<EnquiryFormStudents />} /> */}
                  </Route>
                  <Route
                    path="lead-management"
                    element={<EnquiryDashboard />}
                  />
                </>
              ) : null}
              {rights?.students === AccessCodes.students ? (
                <Route path="/student" element={<StudentsList />} />
              ) : null}

              {rights?.students === AccessCodes.students ? (
                <Route
                  path="/student/:id"
                  element={
                    <NewStudentForm type={CandidateRequestType.Student} />
                  }
                />
              ) : null}

              {rights?.lms === AccessCodes.lms && (
                // <Route path="/student" element={<StudentsList />} />
                <>
                  <Route
                    path="/class&Subjects"
                    element={<ClassandSubjects />}
                  />
                  <Route
                    path="/subject-allocation"
                    element={<SubjectAllocationList />}
                  />
                  <Route path="/manage-schedule" element={<ManageSchedule />} />
                  <Route
                    path="/lessionPlanning"
                    element={<LessionPlanning />}
                  />
                  <Route path="/graduationalumni" element={<Degree />} />
                </>
              )}
              {/* {<Route path="Batch" element={<Batch />} />} */}
              {rights?.documents === AccessCodes.documents ? (
                <Route path="settings/Document" element={<Document />} />
              ) : null}
              {rights?.credentials === AccessCodes.credentials ? (
                <Route path="settings/Credentials" element={<Credentials />} />
              ) : null}
              {rights?.counselor === AccessCodes.counselor ? (
                <Route path="settings/Counselor" element={<Counselor />} />
              ) : null}

              {/* <Route path="Category" element={<Category />} /> */}
              {/* <Route path="Gender" element={<Master />} /> */}
              {/* {<Route path="Gender" element={<Gender />} />} */}

              {rights?.attendance === AccessCodes.attendance ? (
                <Route path="attendance" element={<Attendance />} />
              ) : null}

              {/* <Route path="Category" element={<Category />} /> */}
              {/* <Route path="Gender" element={<Master />} /> */}
              {/* {<Route path="Gender" element={<Gender />} />} */}
              {rights?.attendance === AccessCodes.attendance ? (
                <Route path="attendance" element={<Attendance />} />
              ) : null}
              <Route path="/requests" element={<RequestsTab />} />
              {rights?.reports === AccessCodes.reports ? (
                // <Route path="reports" element={<Reports/>}/>
                <Route path="reports/*">
                  <Route index element={<Reports />} />
                  <Route
                    path="datewiseattendance"
                    element={<DatewiseAttReport />}
                  />
                  <Route
                    path="workinghoursreport"
                    element={<WorkingHoursReport />}
                  />
                  <Route
                    path="cousellorTataReport"
                    element={<CounsellorTataReport />}
                  />
                  <Route
                    path="cousellorLeadReport"
                    element={<CounsellorLeadManagementReport />}
                  />
                </Route>
              ) : null}
              {/* <Route path="Course" element={<Course />} /> */}
              {/* <Route path="Subjects" element={<Subjects />} /> */}
              {/* <Route path="Semesters" element={<Semester />} /> */}
              {/* <Route path="Departments" element={<Department />} /> */}
              {rights?.fees === AccessCodes.fees ? (
                <Route path="/fees" element={<Fees />} />
              ) : null}
              <Route path="/payment-order" element={<PaymentOrders />} />
              {rights?.assessment === AccessCodes.assessment && (
                <Route
                  path="/assessments-grades"
                  element={<DisplayAssements />}
                />
              )}

              <Route path="/exams" element={<ExamsList />} />

              {/* {<Route path="/examSection" element={} />} */}
              {rights?.gradeBook === AccessCodes.gradeBook && (
                <Route
                  path="gradebook/*"
                  element={
                    <>
                      <Routes>
                        <Route path="/" element={<GradeBook />} />
                        <Route
                          path="/marks-entry-all-subjects"
                          element={<AddAllSubjectMarks />}
                        />
                        <Route
                          path="/marks-entry-single-subjects"
                          element={<AddSingleSubjectMarks />}
                        />
                        <Route
                          path="/single-student-result"
                          element={<SingleStudentResult />}
                        />
                        <Route
                          path="/re-evaluation-queries"
                          element={<QueryList />}
                        />
                        <Route
                          path="/check-exams-list"
                          element={<CheckExamList />}
                        />
                        <Route
                          path="/check-exams-list/:examId"
                          element={<ExamStudentsAnswerSheetList />}
                        />
                        <Route
                          path="/check-exams-list/:examId/:studentId"
                          element={
                            <ExamIndividualStudentAnswerSheet
                              readOnly={false}
                            />
                          }
                        />
                      </Routes>
                    </>
                  }
                ></Route>
              )}

              {rights?.callLogs === AccessCodes.callLogs && (
                <Route path="call-logs" element={<TATACallLogs />} />
              )}
              {/* {rights?.enquiryLead === AccessCodes.enquiryLead ? ( */}
              <Route path="Holiday" element={<Holiday />} />
              <Route path="notice" element={<NoticeList />} />

              {rights?.settings === AccessCodes.settings ? (
                <Route
                  path="settings/*"
                  element={
                    <>
                      <Routes>
                        <Route path="/" element={<Setting />} />
                        {rights?.settings === AccessCodes.settings ? (
                          <Route path="/users" element={<User />} />
                        ) : null}
                        {rights?.curriculums === AccessCodes.curriculums ? (
                          <Route path="/Curriculum" element={<Curriculum />} />
                        ) : null}
                        {rights?.streams === AccessCodes.streams ? (
                          <Route path="/Stream" element={<Stream />} />
                        ) : null}
                        {rights?.classes === AccessCodes.classes ? (
                          <Route path="Class" element={<Class />} />
                        ) : null}
                        {rights?.paymentMedium === AccessCodes.paymentMedium ? (
                          <Route path="Payment" element={<PaymentMedium />} />
                        ) : null}
                        {rights?.credentials === AccessCodes.credentials ? (
                          <Route path="Credentials" element={<Credentials />} />
                        ) : null}
                        {rights?.documents === AccessCodes.documents ? (
                          <Route path="Document" element={<Document />} />
                        ) : null}
                        {rights?.documents === AccessCodes.documents ? (
                          <Route
                            path="mandatory-document-type"
                            element={<MandatoryDocumentType />}
                          />
                        ) : null}
                        {rights?.holidays === AccessCodes.holidays ? (
                          <Route path="Holiday" element={<Holiday />} />
                        ) : null}
                        {rights?.status === AccessCodes.status ? (
                          <Route path="admission-status" element={<Status />} />
                        ) : null}
                        {rights?.medium === AccessCodes.medium ? (
                          <Route path="Medium" element={<Medium />} />
                        ) : null}
                        {rights?.role === AccessCodes.role ? (
                          <Route path="Role" element={<RoleList />} />
                        ) : null}
                        {rights?.feesType === AccessCodes.feesType ? (
                          <Route path="fees-type" element={<FeesType />} />
                        ) : null}
                        {/* {rights?.feesType === AccessCodes.feesType ? (
                        <Route path="processSteps" element={<ProcessSteps />} />
                      ) : null} */}
                        {rights?.feesType === AccessCodes.feesType ? (
                          <Route path="fees-type" element={<FeesType />} />
                        ) : null}
                        <Route path="Source" element={<Source />} />
                        {/* <Route path="AssignTo" element={<AssignTo />} /> */}
                        <Route path="User" element={<User />} />
                        <Route path="Reason" element={<Reason />} />
                        <Route path="PlatForm" element={<Platform />} />
                        <Route path="Reminder" element={<Reminder />} />
                        <Route path="Task" element={<Task />} />
                        <Route
                          path="mail-template"
                          element={<MailTemplates />}
                        />
                        <Route
                          path="assessment-category"
                          element={<AssesmentCategoryList />}
                        />
                        <Route
                          path="examination-instructions-template"
                          element={<ExamTemplatesList />}
                        />
                        <Route
                          path="identity-cards-template"
                          element={<IDCardTemplate />}
                        />

                        <Route path="Course" element={<Course />} />
                        <Route path="Session" element={<Session />} />
                        <Route path="Semester" element={<Semester />} />
                        <Route path="Batch" element={<Batch />} />
                        <Route path="Subject" element={<Subjects />} />
                        <Route path="Sections" element={<Sections />} />
                        <Route path="Room" element={<Room />} />
                        <Route
                          path="design-course"
                          element={<DesignCourse />}
                        />
                        {<Route path="Gender" element={<Gender />} />}

                        <Route
                          path="faculty-map-with-dept"
                          element={<FacultyMapWithDept />}
                        />
                        <Route path="faculty-type" element={<FacultyType />} />
                        <Route path="shift-list" element={<ShiftList />} />
                        <Route
                          path="fees-structure"
                          element={<FeesStructure />}
                        />
                        <Route path="eCard" element={<Ecard />} />
                        <Route
                          path="subject-types"
                          element={<SubjectTypes />}
                        />
                        <Route path="notice" element={<NoticeList />} />
                        <Route
                          path="privacy-policy"
                          element={<PrivacyPolicy />}
                        />
                        <Route path="leave-types" element={<LeaveTypes />} />
                        <Route
                          path="biometric-device"
                          element={<BioMetricDeviceList />}
                        />
                        <Route
                          path="biometric-device/:id"
                          element={<BioMetricDeviceEmployeeList />}
                        />
                        <Route
                          path="appVersions"
                          element={<AppVersionsList />}
                        />
                        <Route
                          path="employee-referral"
                          element={<EmployeeReferralList />}
                        />

                        {/* Process Steps For Website */}
                        {rights?.feesType === AccessCodes.feesType ? (
                          // <Route path="processStepsForWebsite" element={<ProcessSteps ProcessType={EnquiryType.Website} />} />
                          <Route
                            path="processStepsForWebsite/*"
                            element={
                              <>
                                <Routes>
                                  <Route
                                    path=""
                                    element={
                                      <>
                                        <ProcessStepSetting
                                          processType={EnquiryType.Website}
                                        />
                                      </>
                                    }
                                  />
                                  <Route
                                    path="addEditProcessSteps"
                                    element={
                                      <>
                                        <ProcessSteps
                                          ProcessType={EnquiryType.Website}
                                        />
                                      </>
                                    }
                                  />
                                  <Route
                                    path="configActions"
                                    element={
                                      <>
                                        <ActionConfiguration
                                          ProcessStepType={EnquiryType.Website}
                                        />
                                      </>
                                    }
                                  />
                                </Routes>
                              </>
                            }
                          />
                        ) : null}
                        {/* Process Steps For Application */}
                        {rights?.feesType === AccessCodes.feesType ? (
                          // <Route path="processStepsForWebsite" element={<ProcessSteps ProcessType={EnquiryType.Website} />} />
                          <Route
                            path="processStepsForApplication/*"
                            element={
                              <>
                                <Routes>
                                  <Route
                                    path=""
                                    element={
                                      <>
                                        <ProcessStepSetting
                                          processType={EnquiryType.Application}
                                        />
                                      </>
                                    }
                                  />
                                  <Route
                                    path="addEditProcessSteps"
                                    element={
                                      <>
                                        <ProcessSteps
                                          ProcessType={EnquiryType.Application}
                                        />
                                      </>
                                    }
                                  />
                                  <Route
                                    path="configActions"
                                    element={
                                      <>
                                        <ActionConfiguration
                                          ProcessStepType={
                                            EnquiryType.Application
                                          }
                                        />
                                      </>
                                    }
                                  />
                                </Routes>
                              </>
                            }
                          />
                        ) : null}
                      </Routes>
                    </>
                  }
                ></Route>
              ) : null}
              {/* Setting routes */}
              {/* {rights?.settings === AccessCodes.settings ? (
              <Route path="settings/*" element={<User />} />
            ) : null} */}
              {/* <Route path="settings/course" element={<CourseSetting />} /> */}
              {/* <Route path="settings/enquiry" element={<EnquirySetting />} /> */}
              {/* <Route path="settings/student" element={<StudentSetting />} /> */}
              {/* <Route path="settings/masters" element={<MasterSetting />} /> */}
              {/* <Route path="settings/attendance" element={<AttendanceSetting />} /> */}
              {/* <Route path="settings/fees" element={<FessSetting />} /> */}

              <Route path="*" element={<Navigate to="/dashboard" />} />
            </Routes>
          </LazyWrapper>
        )}
      {userRoleType === RoleTypes.Student && (
        <LazyWrapper>
          <Routes>
            <Route path="/" element={<Navigate to="/exam" />} />
            <Route path="/enable-2fa" element={<Enable2FA/>}/>
            <Route path="exam" element={<StudentExamList />} />
            <Route path="exam/:id" element={<StudentExam />} />

            <Route
              path="exam/examInstructions"
              element={<ExamInstructions />}
            />
            <Route path="results" element={<StudentResultList />} />
            <Route
              path="/results/:examId/:studentId"
              element={<ExamIndividualStudentAnswerSheet readOnly={true} />}
            />
            <Route path="*" element={<Navigate to="/exam" />} />
          </Routes>
        </LazyWrapper>
      )}
      {userRoleType === RoleTypes.SuperAdmin && (
        <LazyWrapper>
          <Routes>
            <Route path="/company" element={<CompanyList />} />
            <Route path="/enable-2fa" element={<Enable2FA/>}/>
            <Route path="/*" element={<Navigate to="/company" />} />
          </Routes>
        </LazyWrapper>
      )}
      {contextHolder}
    </adminContext.Provider>
  );
};
export default PageRoute;
